import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Waveform.svg'

export const IconWaveForm = IconSVG as IconComponent
